import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router';
import * as ThemeManager from '../../services/themeManager';
import Alert from '../common/Alert';
import LoadingIndicator from '../common/LoadingIndicator';
import NNLogo from '../common/NNLogo';
import BackLink from './components/BackLink';
import CountriesSelectView from './components/CountriesSelectView';
import LegalsContent from './components/LegalsContentView';
import * as Selectors from './store/selectors';
import { EArticleAlias, ELegalsViews, IArticle } from './types';

interface RouteParams {
  type: EArticleAlias;
}

export interface IAppWrapperProps {
  ready: boolean;
  articles: IArticle[];
  view: ELegalsViews;
  error: string;
}

export const AppWrapper: React.FC<IAppWrapperProps> = ({ ready, articles, view, error }) => {
  const { type } = useParams<RouteParams>();
  const { language, t } = useTranslation();

  if (!ready || !language) {
    return <LoadingIndicator />;
  }
  const errorWidget = error ? <Alert>{t(error)}</Alert> : null;
  const viewWrapper = (view: ELegalsViews) => {
    switch (view) {
      case ELegalsViews.SelectCountry:
        return <CountriesSelectView type={type as EArticleAlias} />;
      case ELegalsViews.Articles:
        return <LegalsContent articles={articles} />;
    }
  };
  return (
    <div className="legals-container container">
      <div className="text-center">
        <NNLogo />
      </div>
      {errorWidget}
      {viewWrapper(view)}
      <ThemeManager.ThemeConsumer>{(theme) => <BackLink theme={theme} />}</ThemeManager.ThemeConsumer>
    </div>
  );
};

export const mapStateToProps = (state: Selectors.IState) => {
  const ready = Selectors.isAppReady(state);
  const articles = Selectors.getArticles(state);
  const view = Selectors.getView(state);
  const error = Selectors.getError(state);
  return { ready, articles, view, error };
};

export default withRouter(connect(mapStateToProps)(AppWrapper));
